module.exports = __webpack_public_path__ + "img/Tropical-day.04c99764.png";